var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('nav-bar'),_c('index-banner'),_c('hot-goods'),_c('daifa-guide'),_c('bottom-footer'),_c('back-top')],1)}
var staticRenderFns = []

export { render, staticRenderFns }